"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var jsx_runtime_1 = require("react/jsx-runtime");
var select_field_1 = require("../../../../../../../components/form/select-field");
var condition_node_1 = __importDefault(require("../condition_node"));
var weekdays_1 = require("../../../../../../../constants/weekdays");
var react_1 = require("react");
var challenge_1 = require("../../../../../../../reducers/slices/challenge/challenge");
var react_redux_1 = require("react-redux");
var challengeEditorContext_1 = require("../../../../../../../contexts/challengeEditorContext");
var RecurringConditionNode = function (props) {
    var isReadOnly = (0, challengeEditorContext_1.useChallengeReadOnly)();
    var data = props.data;
    var dispatch = (0, react_redux_1.useDispatch)();
    var setConfigData = function (config) {
        dispatch((0, challenge_1.setNode)(__assign(__assign({}, props), { data: __assign(__assign({}, data), { config: config }) })));
    };
    var frequencyLabels = {
        daily: "day(s)",
        weekly: "week(s)",
        monthly: "month(s)",
        yearly: "year(s)",
    };
    var frequencyOptions = [
        { key: "daily", label: "Daily" },
        { key: "weekly", label: "Weekly" },
        // { key: "monthly", label: "Monthly" },
        // { key: "yearly", label: "Yearly" },
    ];
    var configurationComponent = function () {
        return ((0, jsx_runtime_1.jsxs)("div", { className: "flex flex-col gap-2", children: [(0, jsx_runtime_1.jsx)(select_field_1.SelectField, { isDisabled: isReadOnly, label: "Frequency", value: data.config.frequency, items: frequencyOptions.map(function (option) { return ({ label: option.label, value: option.key }); }), onChange: function (value) {
                        setConfigData(__assign(__assign({}, data.config), { frequency: value }));
                    } }), data.config.frequency == "weekly" && ((0, jsx_runtime_1.jsx)(select_field_1.SelectField, { isDisabled: isReadOnly, label: "Day", value: data.config.day, items: weekdays_1.daysOfTheWeek.slice(0, -2).map(function (option) { return ({ label: option.day, value: option.key }); }), onChange: function (value) {
                        setConfigData(__assign(__assign({}, data.config), { day: value }));
                    } }))] }));
    };
    return (0, jsx_runtime_1.jsx)(condition_node_1.default, __assign({ data: data }, props, { configurationComponent: configurationComponent }));
};
exports.default = (0, react_1.memo)(RecurringConditionNode);
